import { deleteCookie, getCookie } from 'cookies-next';
import { redirect } from 'next/navigation';
import { useApp } from '@/forApp/states/appState/appState'; // Import for server-side redirection
import type { ApiResponse } from '@/forApp/utils/fetcher/types';

type HttpMethod = 'PUT' | 'DELETE' | 'GET' | 'POST' | 'PATCH';

async function fetcher<T>(
  method: HttpMethod,
  url: string,
  init?: RequestInit,
  params?: Record<string, string>,
  responseType?: 'json' | 'blob',
): Promise<ApiResponse<T>> {
  try {
    const token = getCookie('cg-token');

    // Check if body is FormData
    const isFormData = init?.body instanceof FormData;

    const headers = token
      ? {
          ...(isFormData
            ? {}
            : {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              }),
          Authorization: `Bearer ${String(token)}`,
          Accept: 'application/json',
        }
      : {
          ...(isFormData
            ? {}
            : {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              }),
        };
    console.log(
      process.env.NEXT_PUBLIC_BASE_URL_API +
        url +
        (params ? '?' : '') +
        new URLSearchParams(params),
      'URL_FETCHER',
    );
    const response = await fetch(
      process.env.NEXT_PUBLIC_BASE_URL_API +
        url +
        (params ? '?' : '') +
        new URLSearchParams(params),
      {
        method,
        headers,
        ...init,
        ...(responseType === 'blob' ? { responseType: 'blob' } : {}),
      },
    );

    if (!response.ok) {
      console.error(url, 'url!');
      console.error(response.status, 'status!');

      let errorMessage = 'HTTP Error: ' + response.status;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch (e) {
        console.error('Error parsing error response', e);
      }
      if (response.status === 404) {
        redirect('/not-found');
      }
      throw new Error(`${errorMessage}`);
    }

    const data =
      responseType === 'blob' ? await response.blob() : await response.json();

    const dataChose = responseType === 'blob' ? data : data.data;
    return {
      success: true,
      data: url === '/pages/faq' ? data : dataChose, // КОСТЫЛЬ
      message: 'OK',
    };
  } catch (error) {
    const { addNotification } = useApp.getState();

    addNotification({ text: (error as Error).message, type: 'error' });

    if ((error as Error).message.includes('HTTP Error: 401')) {
      deleteCookie('cg-token');
      window.location.href = '/';
    }

    throw error;
  }
}

export const fetcherSWR = async (url: string) => {
  const token = getCookie('cg-token');
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const r = await fetch(url, {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
  });
  return r.json();
};
export default fetcher;
